export default __webpack_public_path__ + "static/media/1675.32ddeb73.png";